/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from "gatsby"

import Header from "../header"
import Footer from "../footer"
import * as styles from './layout.module.scss'

const Layout = ({ children, featuredImage, setScrollBelowContent }) => {
  const mainContentRef = React.createRef();
  const heroImgRef = React.useRef(null);

  const [scrollTop] = useState(0);

  const heroSrc = featuredImage?.node?.localFile?.publicURL;

  // Handle cached images: onLoad won't fire if image is already in browser cache
  useEffect(() => {
    const img = heroImgRef.current;
    if (img && img.complete && img.naturalWidth > 0) {
      img.style.opacity = 1;
    }
  }, [heroSrc]);

  const handleHeroLoad = (e) => {
    e.currentTarget.style.opacity = 1;
  };

  const data = useStaticQuery(graphql`
    query {
      wp {
        generalSettings {
          title
          url
        }
      }
      pages: allWpPage(sort: {order: ASC, fields: menuOrder}) {
        nodes {
          id
          title
          slug
        }
      }
    }
  `)

  useEffect(() => {
    const onScroll = e => {
      if (mainContentRef.current && setScrollBelowContent) {
        if (window.scrollY > mainContentRef.current.offsetTop) {
          setScrollBelowContent(true);
        } else {
          setScrollBelowContent(false);
        }
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop, mainContentRef, setScrollBelowContent]);

  return (
    <>
      <div className={styles.grid}>
        <div className={styles.layoutHeader}>
          <Header siteTitle={data.wp?.generalSettings?.title} navigation={data.pages?.nodes || data.pages?.edges} />
        </div>
        <main className={styles.layoutMain}>
          {
            featuredImage && (
              <div key={heroSrc} className={styles.featuredImage}>
                <img
                  ref={heroImgRef}
                  className={`${featuredImage.node.imageCustomFields ? `object-position-${featuredImage.node.imageCustomFields.position}` : 'object-position-center'}`}
                  src={heroSrc}
                  alt={featuredImage.node.altText}
                  style={{ opacity: 0, transition: 'opacity 1.2s ease' }}
                  onLoad={handleHeroLoad}
                />
              </div>
            )
          }
          <div ref={mainContentRef} >
            {children}
          </div>
        </main>

        <div className={styles.layoutFooter}>
          <Footer />
        </div>
      </div>
    </>
  )
}


export default Layout
